/* eslint-disable semi */
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './tailwind.css';
import './styles/main.scss'

ReactDOM.render(<App />, document.getElementById('root'));
